/*******************************************
 * All Animations *
 * We are using slickslider to handle all sliders *
 *******************************************/

jQuery(document).ready(function($) {
    //Stops GSAP from checking for the elements on the pages
    //This is annoying since we use flex fields and not all elements are on a pages
    //Greensock Config
    gsap.config({
        nullTargetWarn: false,
    });

 
    /***********************
     Flex Fields
    ***********************/
   // Basic Content
   const basicContent = document.querySelectorAll(".basic-content");
   basicContent.forEach(basicContent => {
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: basicContent,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        .from(basicContent.querySelectorAll(".container > h2, .container > .content"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
    });

    // Media with text
    const mediaText = document.querySelectorAll(".image-with-text");
    mediaText.forEach(mediaText => {
        const mediaTextTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: mediaText ,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        // Animate the content items
        .from(mediaText.querySelectorAll('h2, .content'), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
            transformOrigin: '50% 50%'
        })
        // Animate the link containers
        const items = mediaText.querySelectorAll(".links div");
        mediaTextTimeline.from(items, {
            duration: .5,
            x: 40,
            opacity: 0,
            stagger: .08,
            transformOrigin: '50% 50%'
        }, 0)
        // Animate the links
        items.forEach((item, i) => {
            mediaTextTimeline.from(item.querySelectorAll("a"), {
            duration: .002,
            x: 40,
            opacity: 0,
            stagger: .002,
            transformOrigin: '50% 50%'
            }, i * .05);
        });
    });

    //Columned Content
    const columns = document.querySelectorAll(".columned-content");
    columns.forEach(columns => {
        const columnsTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: columns,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none",
            }
        })
        // Animate the header items
        .from(columns.querySelectorAll('h2'), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
            transformOrigin: '50% 50%'
        })
        // Animate the callout items
        const items = columns.querySelectorAll(".callout");
        columnsTimeline.from(items, {
            duration: .5,
            x: 40,
            opacity: 0,
            stagger: .05,
        }, 0)    
        // Animate the items in the callouts
        items.forEach((item, i) => {
            columnsTimeline.from(item.querySelectorAll(".callout > *"), {
            duration: .5,
            y: 100,
            opacity: 0,
            stagger: .08
            }, i * .05);
        });
    });
    

    //Logos
    const logos = document.querySelectorAll(".logo-list");
    logos.forEach(logos => {
        const logosTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: logos,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        // Animate the header items
        .from(logos.querySelectorAll('h2, .content'), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
            transformOrigin: '50% 50%'
        })
        // Animate the callout items
        const logoItem = logos.querySelectorAll(".logo-wrap .logo");
        logosTimeline.from(logoItem, {
            duration: .5,
            x: 40,
            opacity: 1,
            stagger: .08,
        }, 0)
        // Animate the items in the callouts
        logoItem.forEach((logoItem, i) => {
            logosTimeline.from(logoItem.querySelectorAll(".logo a img"), {
            duration: .5,
            y: 100,
            opacity: 0,
            stagger: .25
            }, i * .05);
        });
    });

    //History
   const historySlider = document.querySelectorAll(".history");
   historySlider.forEach(historySlider => {
        const historyTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: historySlider,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        .from(historySlider.querySelectorAll(".intro > *, .history-wrap"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
    });

     // 50/50
     const fiftyfifty = document.querySelectorAll(".fifty-fifty");
     fiftyfifty.forEach(fiftyfifty => {
         const fiftyfiftyTimeline = gsap.timeline({
             scrollTrigger: {
             trigger: fiftyfifty ,
             start: "20% bottom",
            end: "bottom bottom",
             toggleActions: "play none none none"
             }
         })
         // Animate Left Text and items
         const leftContent = fiftyfifty.querySelectorAll(".content-left");
         fiftyfiftyTimeline.from(leftContent, {
             duration: .5,
             y: 40,
             opacity: 0,
             stagger: .25,
             transformOrigin: '50% 50%'
         }, 0)        
         // Animate the left link area
         leftContent.forEach((leftContent, i) => {
            fiftyfiftyTimeline.from(leftContent.querySelectorAll(".content-left > *"), {
             duration: .5,
             x: 40,
             opacity: 0,
             stagger: .08,
             transformOrigin: '50% 50%'
             }, i * .05);
         });
         // Animate the left links
         leftContent.forEach((leftContent, i) => {
            fiftyfiftyTimeline.from(leftContent.querySelectorAll(".links a"), {
             duration: .005,
             x: 40,
             opacity: 0,
             stagger: .25,
             transformOrigin: '50% 50%'
             }, i * .05);
         });
         //Animate all right items
         const rightContent = fiftyfifty.querySelectorAll(".content-right");
         fiftyfiftyTimeline.from(rightContent, {
             duration: .5,
             y: 40,
             opacity: 0,
             stagger: .25,
             transformOrigin: '50% 50%'
         }, 0)
         rightContent.forEach((rightContent, i) => {
            fiftyfiftyTimeline.from(rightContent.querySelectorAll(".content-right > *"), {
             duration: .25,
             x: 40,
             opacity: 0,
             stagger: .05,
             transformOrigin: '50% 50%'
             }, i * .05);
         });
         // Animate the right links
         rightContent.forEach((rightContent, i) => {
            fiftyfiftyTimeline.from(rightContent.querySelectorAll(".links a"), {
             duration: .25,
             x: 40,
             opacity: 0,
             stagger: .005,
             transformOrigin: '50% 50%'
             }, i * .05);
         });
     });

     //Quote
   const Quote = document.querySelectorAll(".quote");
   Quote.forEach(Quote => {
        const quoteTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: Quote,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        .from(Quote.querySelectorAll(".container"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
        
    });

    // Content Slider
   const contentSlider = document.querySelectorAll(".content-slider");
   contentSlider.forEach(contentSlider => {
        const contentSliderTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: contentSlider,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        .from(contentSlider.querySelectorAll(".intro > *, .slide-wrap"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
    });

    // Gallery Slider
   const GallerySlider = document.querySelectorAll(".gallery-slider");
   GallerySlider.forEach(GallerySlider => {
        const gallerySliderTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: GallerySlider,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        .from(GallerySlider.querySelectorAll(".gallery-slider > *"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
    });

    // Featured Slider
   const featuredSlider = document.querySelectorAll(".featured-project");
   featuredSlider.forEach(featuredSlider => {
        const featuredSliderTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: featuredSlider,
            start: "20% bottom",
            end: "bottom bottom",
            toggleActions: "play none none none"
            }
        })
        .from(featuredSlider.querySelectorAll(".intro, .projects-wrap"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
    });

   // Front Page Hero Video
    const HomeHeroVideo = document.querySelectorAll(".home .hero-slider");
   // const featuredSlider = document.querySelectorAll(".featured-project");
    HomeHeroVideo.forEach(HomeHeroVideo => {
          const HomeHeroVideoTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: HomeHeroVideo,
                scrub: true,
                start: "top 100%+=100px",
                end: 'bottom top',
                toggleActions: "play reverse play reverse",

                onEnter() {
                    if ($('.home .hero-slider .slick-current video').length){
                        $('.home .hero-slider .slick-current video')[0].currentTime = 0;
                        $('.home .hero-slider .slick-current video')[0].play();
                    }
                },
                onLeave() {
                    if ($('.home .hero-slider .slick-current video').length){
                        $('.home .hero-slider .slick-current video')[0].pause();
                        $('.home .hero-slider .slick-current video')[0].currentTime = 0;
                    }
                },
                onEnterBack() {
                    if ($('.home .hero-slider .slick-current video').length){
                        $('.home .hero-slider .slick-current video')[0].currentTime = 0;
                        $('.home .hero-slider .slick-current video')[0].play();
                    }
                },
                onLeaveBack() {
                    if ($('.home .hero-slider .slick-current video').length){
                        $('.home .hero-slider .slick-current video')[0].pause();
                        $('.home .hero-slider .slick-current video')[0].currentTime = 0;
                    }
                },
            }
        })
    });

    //posts
    const posts = document.querySelectorAll(".latest-news");
    posts.forEach(posts => {
        const postsTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: posts,
            start: "-=200 center",
            end: "bottom bottom",
            toggleActions: "play none none none",
            }
        })
        // Animate the header items
        .from(posts.querySelectorAll('.intro'), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
            transformOrigin: '50% 50%'
        })

        // Animate the post container
        const postItem = posts.querySelectorAll(".post");
        postsTimeline.from(postItem, {
            duration: .5,
            x: 40,
            opacity: 0,
            stagger: .25,
        }, 0)
        
        // Animate the items in the posts
        postItem.forEach((postItem, i) => {
            postsTimeline.from(postItem.querySelectorAll(".post > *"), {
            duration: .5,
            y: 100,
            opacity: 0,
            stagger: .25
            }, i * .25);
        });
    });

    //Animate News Items
    ScrollTrigger.batch(".post-list .posts-list-ajax .card", {
        onEnter: elements => {
          gsap.from(elements, {
            autoAlpha: 0,
            y: 60,
            stagger: 0.15
          });
        },
        once: true
      });

     // Single Post
   const singleContent = document.querySelectorAll(".single-post .post-content");
   singleContent.forEach(singleContent => {
        const singlePostTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: singleContent,
            start: "top bottom",
            end: "bottom center",
            toggleActions: "play none none none"
            }
        })
        .from(singleContent.querySelectorAll(".content > *"), {
            duration: .2,
            y: 40,
            opacity: 0,
            stagger: .2,
        })
    });


    if ($(this).width() >= 768) {
        const parallaxSlider = document.querySelectorAll(".parallax-slider");
        parallaxSlider.forEach(parallaxSlider => {

            const containers = gsap.utils.toArray(".parallax-slider .container");
            containers.forEach((container, i) => {
            let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        scrub: true,
                        pin:'.parallax-content-wrap',
                        start: "top top",
                        end: 'bottom top',
                        toggleActions: "play reverse play reverse",
                        onEnter() {
                            container.classList.add('enable');
    
                            $('.slide-wrap').slick('slickGoTo', '0');
                            $('.slick-active').removeClass("remove-animation");

                            
                        },
                        onLeave() {
                            container.classList.remove('enable');
                        
                            $('.slick-active').addClass("remove-animation");
                        },
                        onEnterBack() {
                            container.classList.add('enable');
     
                            $('.slide-wrap').slick('slickGoTo', '0');
                            $('.slick-active').removeClass("remove-animation");
    
                        },
                        onLeaveBack() {
                            container.classList.remove('enable');
                            $('.slick-active').addClass("remove-animation");

                            // $('.parallax-slider .slide-wrap .slick-cloned video').each(function () {
                            //     $(this)[0].pause();
                            //     $(this)[0].currentTime = 0;
                            // });
                            //$('.slide-wrap').slick('destroy');
                        }
                    }
                });
            });
        

            let links = gsap.utils.toArray(".parallax-nav a");
            
            links.forEach(a => {
            let element = document.querySelector(a.getAttribute("href")),
                linkST = ScrollTrigger.create({
                        trigger: element,
                        start: "top top",
                        
                    });
            ScrollTrigger.create({
                trigger: element,
                start: "top top",
                end: "bottom top",
                onToggle: self => self.isActive && setActive(a)
            });
            a.addEventListener("click", e => {
                e.preventDefault();
                gsap.to(window, {
                    duration: .5, 
                    scrollTo: 
                        linkST.start + 20, 
                        overwrite: "auto"
                });
            });
            });

            function setActive(link) {
            links.forEach(el => el.classList.remove("active"));
            link.classList.add("active");
            }

                    
        });
    } else {
        const parallaxSlider = document.querySelectorAll(".parallax-slider");
        parallaxSlider.forEach(parallaxSlider => {

            const containers = gsap.utils.toArray(".parallax-slider .container");
            containers.forEach((container, i) => {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        scrub: true,
                        start: "top top",
                        end: 'bottom top',
                        toggleActions: "play reverse play reverse",
                        onEnter() {
                            $('.parallax-slider .slide-wrap .slick-current video').each(function () {
                                $(this)[0].currentTime = 0;
                                $(this)[0].play();

                            });
                        },
                        onLeave() {
                            $('.parallax-slider .slide-wrap .slick-cloned video').each(function () {
                                $(this)[0].pause();
                                $(this)[0].currentTime = 0;
                            });
                        },
                        onEnterBack() {
                            $('.parallax-slider .slide-wrap .slick-current video').each(function () {
                                $(this)[0].currentTime = 0;
                                $(this)[0].play();
                            });
                        },
                        onLeaveBack() {
                            $('.parallax-slider .slide-wrap .slick-cloned video').each(function () {
                                $(this)[0].pause();
                                $(this)[0].currentTime = 0;
                            });
                        }
                    }
                });
            });
        });
    }


    const navList = document.querySelectorAll(".parallax-nav");
    navList.forEach(navList => {
          const navListTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".parallax-slider",
                start: "top top", 
                end: "bottom 100%-=100px",
            
                onEnter() {
                    navList.classList.add('enable');
                },
                onLeave() {
                    navList.classList.remove('enable');
                },
                onEnterBack() {
                    navList.classList.add('enable');
                },
                onLeaveBack() {
                    navList.classList.remove('enable');
                },
            }
        })
    });



    // Projects
    // const projects = document.querySelectorAll(".project-grid > ul");
    // projects.forEach(projects => {
    //     const projectsTimeline = gsap.timeline({
    //         scrollTrigger: {
    //         trigger: projects,
    //         start: "20% bottom",
    //         end: "bottom bottom",
    //         markers: 'true',
    //         toggleActions: "play none none none"
    //         }
    //     })


    //     // Animate the post container
    //     // const projectItem = projects.querySelectorAll(".project");
    //     // projectsTimeline.from(projectItem, {
    //     //     duration: .5,
    //     //     y: 0,
    //     //     opacity: 0,
    //     //     stagger: .25,
    //     // }, 0)
    // });



       // Single Project Hero Video
    const projectHeroVideo = document.querySelectorAll(".single-project .hero-slider");
    projectHeroVideo.forEach(projectHeroVideo => {
          const projectHeroVideoTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: projectHeroVideo,
                scrub: true,
                start: "top 100%+=100px",
                end: 'bottom top',
                toggleActions: "play reverse play reverse",

                onEnter() {
                    if ($('.single-project .hero-slider > video').length){
                        $('.single-project .hero-slider > video')[0].currentTime = 0;
                        $('.single-project .hero-slider > video')[0].play();
                    }
                },
                onLeave() {
                    if ($('.single-project .hero-slider > video').length){
                        $('.single-project .hero-slider > video')[0].pause();
                        $('.single-project .hero-slider > video')[0].currentTime = 0;
                    }
                },
                onEnterBack() {
                    if ($('.single-project .hero-slider > video').length){
                        $('.single-project .hero-slider > video')[0].currentTime = 0;
                        $('.single-project .hero-slider > video')[0].play();
                    }
                },
                onLeaveBack() {
                    if ($('.single-project .hero-slider > video').length){
                        $('.single-project .hero-slider > video')[0].pause();
                        $('.single-project .hero-slider > video')[0].currentTime = 0;
                    }
                },
            }
        })
    });

    gsap.set(".page-template-page-project-list .project-grid .project, .single-market .project-grid .project", {opacity: 0});

    ScrollTrigger.batch(".page-template-page-project-list .project-grid .project, .single-market .project-grid .project", {
    interval: 0.1, // time window (in seconds) for batching to occur. 
    batchMax: 2,   // maximum batch size (targets). Can be function-based for dynamic values
    onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 2]}, overwrite: true}),
   // onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
    onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
   // onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 0, overwrite: true}),
    // you can also define most normal ScrollTrigger values like start, end, etc.
    start: "20px 75%",
    end: "top top"
    });

    // when ScrollTrigger does a refresh(), it maps all the positioning data which 
    // factors in transforms, but in this example we're initially setting all the ".box"
    // elements to a "y" of 100 solely for the animation in which would throw off the normal 
    // positioning, so we use a "refreshInit" listener to reset the y temporarily. When we 
    // return a gsap.set() in the listener, it'll automatically revert it after the refresh()!
    ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".page-template-page-project-list .project-grid .project, .single-market .project-grid .project", {opacity: 1}));

        
        
});


